'use client';
import React from 'react';

const withRef = () => (Component) => {
  const WrappedComponent = React.forwardRef((props, ref) => (
    <Component {...props} forwardedRef={ref} />
  ));

  WrappedComponent.displayName = Component.displayName || Component.name;

  return WrappedComponent;
};

export default withRef;
